import type * as Match3Types from './match3.ruleset';
import * as match3Ruleset from './match3.ruleset';
import { match3Schema } from './match3.schema';
import { match3Getters } from './match3.getters';
import { match3Modifiers } from './match3.modifiers';
import { match3Actions } from './match3.actions';
import { Immutable } from '@play-co/replicant';
import { Inventory } from '../../buruburu/inventory';
import { ReplicantModuleState } from '../../utils';

export type Match3 = typeof Match3;
// eslint-disable-next-line no-redeclare
export namespace Match3 {
  export const $DEPENDENCIES = { Inventory };

  export const ruleset = match3Ruleset;
  export const schema = match3Schema({ ruleset });
  export const getters = match3Getters({ ruleset });
  export const modifiers = match3Modifiers({ ruleset });
  export const actions = match3Actions(
    { ruleset, schema, getters, modifiers },
    $DEPENDENCIES,
  );

  export type MutableState = ReplicantModuleState<Match3>;
  export type State = Immutable<MutableState>;
  export type BoardState = MutableState['match3']['board'];
  export type BlockType = BoardState[number][number];
  export type BoardPosition = Match3Types.BoardPosition;
  export type PositionSwap = Match3Types.PositionSwap;
}
